import CardLayout from '../Layout/CardLayout';
import DocumentIcon from '../Icons/DocumentIcon';
import { ReactNode } from 'react';
import { IDocument } from '@/interfaces/user.model';
import Sanitized from './Sanitized';
export interface ICardDetail {
  label: string;
  value: string | undefined | ReactNode;
}
interface IDetailCardProps {
  cardDetails?: ICardDetail[];
  logo?: string;
  title?: string;
  profile?: string;
  documents?: IDocument[] | IDocument[];
  ckeditor?: boolean;
  handleDocumentClick?: (doc: IDocument | string) => void;
  tANDc?: string;
}
const DetailCard = ({
  logo,
  cardDetails,
  title,
  documents,
  ckeditor,
  tANDc,
  profile,
  handleDocumentClick,
}: IDetailCardProps) => {
  return (
    <CardLayout>
      {title && (
        <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
          <h4 className="d-flex align-items-center mb-4">{title}</h4>
        </div>
      )}

      <ul className={'row list-unstyled mt-4'}>
        {ckeditor && <Sanitized description={tANDc ?? ''} />}
        {documents &&
          (documents?.length > 0 ? (
            documents?.map((doc, index) => {
              return (
                <li key={index} className="col-12">
                  <div
                    className="text-muted fs-4 d-flex gap-2 text-decoration-none mb-2"
                    onClick={
                      handleDocumentClick
                        ? () => handleDocumentClick(doc)
                        : () => {}
                    }
                    role="button"
                  >
                    <DocumentIcon />
                    {doc?.name || 'Document'}
                  </div>
                </li>
              );
            })
          ) : (
            <div>No Document Found</div>
          ))}
        {logo && (
          <li className="col-12 col-md-6 col-lg-4">
            <p>
              <span className="text-muted fs-5 d-block">
                {'Company Logo'} :-
              </span>
              <img width={'50px'} src={logo} loading="lazy" />
            </p>
          </li>
        )}
        {profile && (
          <li className="col-12">
            <div>
              <img
                loading="lazy"
                className="detail-img"
                src={profile}
                alt="Employee Profile"
                role="button"
                onClick={() => {
                  handleDocumentClick?.(profile);
                }}
              />
            </div>
          </li>
        )}
        {cardDetails?.map((detail) => {
          return (
            <li className="col-12 col-md-6 col-lg-4">
              <p>
                <span className="text-muted fs-5 d-block">
                  {detail.label} :-
                </span>
                {detail.value || '--'}
              </p>
            </li>
          );
        })}
      </ul>
    </CardLayout>
  );
};
export default DetailCard;
